<template lang="pug">
.loading-indicator.text-center
  //- | ...
  div(
    :class="spinnerClass"
  )
</template>

<script>
export default {
  props: {
    type: {
      default: 'spin',
      validator: s => ['grow', 'spin'].includes(s),
    },
    sm: {
      default: false,
    },
  },
  computed: {
    spinnerClass() {
      let spinnerClass = '';
      switch (this.type) {
        case 'grow':
          spinnerClass = 'spinner-grow';
          if (this.sm === true) {
            spinnerClass += ' spinner-grow-sm';
          }
          break;
        default: // spin & other gibberish values
          spinnerClass = 'spinner-border';
          if (this.sm === true) {
            spinnerClass += ' spinner-border-sm';
          }
      }


      return spinnerClass;
    },
  },
};
</script>

<style lang="scss">
.loading-indicator {
  .spinner-border-sm {
    border-width: 2px;
  }
}
</style>
